export type SelectionHighlightTargetType = "body" | "mesh" | "visualGeom" | "joint";

export type SelectionHighlightUiState = Record<SelectionHighlightTargetType, boolean>;

export const SELECTION_HIGHLIGHT_UI_EVENT = "selection-highlight-ui-change";

export const DEFAULT_SELECTION_HIGHLIGHT_UI_STATE: SelectionHighlightUiState = {
  body: false,
  mesh: false,
  visualGeom: false,
  joint: true,
};

export function dispatchSelectionHighlightUiState(
  targetType: SelectionHighlightTargetType,
  enabled: boolean
) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(SELECTION_HIGHLIGHT_UI_EVENT, {
      detail: { targetType, enabled },
    })
  );
}
